/* Trend Tonic header + footer behaviour · tt-header.js (loaded with defer, safe to load twice) */
(function () {
  if (window.TTHeader) return;
  var mqMobile = window.matchMedia('(max-width: 749px)');

  function initHeader(h) {
    if (h._tt) return; h._tt = true;
    var wrap = h.parentElement; // the .shopify-section wrapper
    var drawer = h.querySelector('[data-tt-drawer]');
    var openBtn = h.querySelector('[data-tt-open-drawer]');
    var lastFocus = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.documentElement.classList.add('tt-lock');
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      openBtn && openBtn.setAttribute('aria-expanded', 'true');
      var f = drawer.querySelector('a, button, summary'); f && f.focus();
    }
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('tt-lock');
      openBtn && openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 320);
      lastFocus && lastFocus.focus && lastFocus.focus();
    }
    openBtn && openBtn.addEventListener('click', openDrawer);
    h.querySelectorAll('[data-tt-close-drawer]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer && drawer.addEventListener('click', function (e) { if (e.target.closest('a[href]')) closeDrawer(); });
    drawer && drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
      if (e.key !== 'Tab') return;
      var f = [].slice.call(drawer.querySelectorAll('a[href], button, summary, input')).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    var desktopSidebar = h.classList.contains('tt-hdr--dm-drawer') || h.classList.contains('tt-hdr--dm-both');
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches && !desktopSidebar) closeDrawer(); });

    // search: TT panel + Dawn predictive search inside it
    var sBtn = h.querySelector('[data-tt-search-toggle]');
    var sBox = sBtn && document.getElementById(sBtn.getAttribute('aria-controls'));
    if (sBtn && sBox) {
      ensureDawnSearch(sBox);
      var ps = sBox.querySelector('predictive-search');
      var closeSearch = function (focusBtn) {
        if (sBox.hidden) return;
        if (ps && typeof ps.close === 'function') { try { ps.close(); } catch (e) {} }
        sBox.hidden = true; sBtn.setAttribute('aria-expanded', 'false');
        if (focusBtn) sBtn.focus();
      };
      sBtn.addEventListener('click', function () {
        if (!sBox.hidden) { closeSearch(false); return; }
        sBox.hidden = false; sBtn.setAttribute('aria-expanded', 'true');
        var i = sBox.querySelector('input[type=search]');
        if (i) { i.focus(); if (i.value) i.dispatchEvent(new Event('input', { bubbles: true })); }
      });
      sBox.querySelectorAll('[data-tt-search-close]').forEach(function (b) { b.addEventListener('click', function () { closeSearch(true); }); });
      sBox.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(true); });
      document.addEventListener('click', function (e) { if (!sBox.hidden && !sBox.contains(e.target) && !sBtn.contains(e.target)) closeSearch(false); });
    }
    // sticky behaviour
    var mode = h.getAttribute('data-sticky');
    var lastY = window.scrollY, ticking = false;
    function onScroll() {
      var y = window.scrollY;
      h.classList.toggle('is-scrolled', y > 4);
      if (mode === 'scroll_up' && wrap) {
        var hide = y > lastY && y > h.offsetHeight * 2 && !(drawer && !drawer.hidden) && !(sBox && !sBox.hidden);
        wrap.classList.toggle('tt-hdr-hidden', hide);
      }
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    // keep the cart bubble in sync with TT add-to-bag
    document.addEventListener('tt:cart:updated', function (e) {
      var link = h.querySelector('#cart-icon-bubble'); if (!link || !e.detail) return;
      var n = e.detail.item_count, bubble = link.querySelector('.cart-count-bubble');
      if (!bubble && n > 0) {
        bubble = document.createElement('div'); bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true" data-cart-count></span>'; link.appendChild(bubble);
      }
      if (bubble) { var sp = bubble.querySelector('span[aria-hidden]'); if (sp) sp.textContent = n; bubble.style.display = n > 0 ? '' : 'none'; }
    });
  }

  // Dawn loads search-form.js and predictive-search.js from theme.liquid. If a theme or layout
  // doesn't, load them here once (search-form.js first, predictive-search.js extends it).
  var dawnLoading = null;
  function loadScript(src) {
    return new Promise(function (res) {
      if (!src) return res();
      var sc = document.createElement('script'); sc.src = src; sc.defer = true;
      sc.onload = res; sc.onerror = res; document.head.appendChild(sc);
    });
  }
  function ensureDawnSearch(box) {
    var hasPS = box.querySelector('predictive-search'), hasSF = box.querySelector('search-form');
    if (!hasPS && !hasSF) return;
    var root = document.querySelector('[data-tt-search-assets]');
    var sf = root && root.getAttribute('data-search-form'), pj = root && root.getAttribute('data-predictive');
    function go() {
      if (dawnLoading) return;
      var need = (hasSF && !customElements.get('search-form')) || (hasPS && !customElements.get('predictive-search'));
      if (!need) return;
      dawnLoading = (customElements.get('search-form') ? Promise.resolve() : loadScript(sf)).then(function () {
        if (hasPS && !customElements.get('predictive-search')) return loadScript(pj);
      });
    }
    // give theme.liquid's deferred scripts time to run first
    if (document.readyState === 'complete') setTimeout(go, 300); else window.addEventListener('load', function () { setTimeout(go, 300); });
  }

  function initFooter(f) {
    if (f._tt) return; f._tt = true;
    if (!f.classList.contains('tt-ftr--acc')) return;
    var details = f.querySelectorAll('details.tt-ftr__acc');
    function sync() {
      details.forEach(function (d) { if (mqMobile.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); });
    }
    sync(); mqMobile.addEventListener('change', sync);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tt-header]').forEach(initHeader);
    (scope || document).querySelectorAll('.tt-ftr').forEach(initFooter);
  }
  window.TTHeader = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
